<template>
  <div>
    <b-card class="w-100">
      <h5
        class="text-center"
        v-if="holdingEnterprises.length === 0"
      >
        No hay datos
      </h5>
      <b-table v-else :busy="loading" :items="holdingEnterprises" :fields="fields">
        <template #cell(see_details)="{ item }">
          <div class="text-center">
            <vs-icon
              icon="assessment"
              class="cursor-pointer"
              size="small"
              @click="showDetails(item.iut)"
              v-tooltip="'Ver detalle'"
            />
          </div>
        </template>
        <template #cell(totalHistoricalWeight)="{ item }">
          {{ item.totalHistoricalWeight }}&nbsp;MB
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HoldingEnterprises',
  props: ['loading'],
  data() {
    return {
      fields: [
        { key: 'enterprise', label: 'Empresa' },
        { key: 'iut', label: 'Rut' },
        { key: 'totalTransactions', label: 'Total transacciones', sortable: true },
        { key: 'totalStorage', label: 'Total almacenamiento', sortable: true },
        { key: 'totalApprovals', label: 'Total aprobaciones', sortable: true },
        { key: 'totalSigns', label: 'Total firmas', sortable: true },
        { key: 'see_details', label: 'Ver detalles' }
      ]
    };
  },
  computed: {
    ...mapGetters('Operations', ['transaccionality']),
    holdingEnterprises() {
      return this.transaccionality.map((t) => ({
        enterprise: t.razonSocial,
        iut: t.iut,
        totalTransactions: t.transacciones.total,
        totalStorage: t.almacenamiento.total,
        totalApprovals: t.aprobaciones.total,
        totalSigns: t.totalFirmas,
        approvals: t.aprobaciones,
        transactions: t.transacciones,
        storage: t.almacenamiento,
        monthlyReport: t.reporteMensual,
        detailReport: t.reporteDetalle
      }));
    }
  },
  methods: {
    showDetails(holdingId) {
      const selectedItem = this.holdingEnterprises.find((item) => item.iut === holdingId);
      this.$router.push({
        name: 'holdingDetail',
        params: {
          enterpriseId: holdingId,
          data: selectedItem
        },
      });
    }
  }
};
</script>
